<template>
  <div class="echart08">
    <div ref="echart08" style="width:100%; height:150px;"></div>
  </div>
  
</template>

<script>
export default {
  props: {
    data08:
            {
              type: Object
            }
  },
  mounted() {
    let chart08 = this.$echarts.init(this.$refs.echart08)
    // let xdata = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30']
    // let ydata1 = [2000, 1800, 2800, 900, 1600, 2000, 3000, 2030, 1356, 1900, 4000, 3000, 2000, 3000, 4200, 3200, 3800, 2000, 1800, 2800, 900, 1600, 2000, 3000, 2030, 1356, 1900, 4000, 3000,3000]
    // let ydata2 = [1000, 800, 800, 900, 600, 1000, 3000, 1030, 356, 1900, 4000, 3000, 100, 1000, 1200, 1200, 1800,1000, 800, 800, 900, 600, 1000, 3000, 1030, 356, 1900, 4000, 3000, 100, 1000, 1200]
    let xdata = this.data08.xAxisData
    let ydata1 = this.data08.ydata1
    let ydata2 = this.data08.ydata2
    let option = {
      backgroundColor:'',
      tooltip: {
        show: true,
        trigger: 'axis',
        backgroundColor: 'rgba(255, 255, 255, .16)', // 设置背景颜色
        textStyle: {
          color: '#fff',
          fontSize: 14
        },
        borderColor: 'rgba(255, 255, 255, .16)',
        axisPointer: {
          lineStyle: {
            color: 'rgba(28, 124, 196, .6)'
          },
        },
        // formatter: "{b}人员类别统计<br>{c}人"
        formatter:function (params, ticket, callback) {
          var htmlStr = '';
          for(var i=0;i<params.length;i++){
            var param = params[i];
            var xName = param.name;//x轴的名称
            var seriesName = param.seriesName;//图例名称
            var value = param.value;//y轴值
            var color = param.color;//图例颜色
            if(i===0){
              htmlStr += xName + '<br/>';//x轴的名称
            }
            htmlStr +='<div>';
            htmlStr += '<span style="margin-right:5px;display:inline-block;width:10px;height:10px;border-radius:5px;background-color:'+color+';"></span>';//一个点
            htmlStr += seriesName + '：' + value + '人';//圆点后面显示的文本
            htmlStr += '</div>';
          }
          return htmlStr;
        }
      },
      color:['#0fe6db', '#fd2d2d', '#16D6FF', '#25D677'],
      legend: {
        // icon: 'circle',
        // itemWidth: 10,
        itemGap: 4,
        x: 'right',
        top: '1%',
        textStyle: {
          color: '#fff',
          fontSize: 12,
          // padding:[0, 6, 0, 6],
        }
      },
      grid: {
        top: '26%',
        left: '6%',
        right: '2%',
        bottom: '19%',
      },
      xAxis: [
        {
          type: 'category',
          axisLine: {
            lineStyle: {
              color: '#2D4377'
            }
          },
          axisLabel: {
            interval: 0,
            align: 'center',
            rotate: '0',
            margin: '0',
            textStyle: {
              fontSize: 12,
              color: '#A9C3F0'
            }
          },
          splitLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          boundaryGap: true,
          data: xdata, //this.$moment(data.times).format("HH-mm") ,
        },
      ],
      yAxis: [
        {
          type: 'value',
          axisLine: {
            lineStyle: {
              color: '#2D4377'
            }
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: '#2D4377',
              type: 'dashed'
            },
          },
          axisLabel: {
            color: '#fff',
            textStyle: {
              fontSize: 12
            }
          },
          axisTick: {
            show: false
          }
        },
      ],
      series: [
        {
          name: '已打卡',
          type: 'line',
          showSymbol: true,
          symbolSize: 8,
          lineStyle: {
            normal: {
              color: '#0fe6db',
            },
          },
          itemStyle: {
            color: '#0fe6db',
            borderColor: '#0fe6db',
            borderWidth: 2,
          },
          // emphasis: {
          //     itemStyle: {
          //         color: "#fff",
          //         borderColor: "#16D6FF",
          //         borderWidth: 2,
          //     },
          // },
          data: ydata1,
        },
        {
          name: '未打卡',
          type: 'line',
          showSymbol: true,
          symbolSize: 8,
          lineStyle: {
            normal: {
              color: '#fd2d2d',
            },
          },
          itemStyle: {
            color: '#fd2d2d',
            borderColor: '#fd2d2d',
            borderWidth: 2,
          },
          // emphasis: {
          //     itemStyle: {
          //         color: "#fff",
          //         borderColor: "#25D677",
          //         borderWidth: 2,
          //     },
          // },
          data: ydata2, //data.values
        },
      ],
    }
    chart08.setOption(option, true)
  }
}
</script>

<style>
.echart08 {
    font-size: 10px;
    font-weight: 700;
    width: 100%;
}
</style>
